import { Button, Stack, Text } from '@chakra-ui/react'
import { useQuery } from '@tanstack/react-query'
import { Link as RouterLink } from 'react-router'
import { api } from '~/api/client'
import { keys } from '~/api/hooks'
import { ActionBar } from '~/components/member/ActionBar'
import { ArtHeading } from '~/components/member/Illustration'
import { MemberLayout } from '~/components/member/layout'
import { useT } from '~/i18n/use-t'

/**
 * An address that is not a page of the site (mobile review): says so and offers the way on, instead of sending a
 * member who mistyped `/me/profil` to "Become a member". "Go to my member page" when the member page is already in the
 * cache (this never asks the server), "Go to the start" otherwise.
 */
export default function NotFound() {
  const { t } = useT()
  const me = useQuery({ queryKey: keys.me, queryFn: () => api('memberMe'), enabled: false })
  const member = Boolean(me.data)
  return (
    <MemberLayout>
      <Stack gap={5}>
        <ArtHeading title={t('notFound.title')} art='peace' />
        <Text>{t('notFound.text')}</Text>
        <ActionBar>
          <Button asChild size='lg' w='full'>
            <RouterLink to={member ? '/me' : '/join'}>{t(member ? 'notFound.member' : 'notFound.start')}</RouterLink>
          </Button>
        </ActionBar>
      </Stack>
    </MemberLayout>
  )
}
